import styled from "styled-components";

export const BodyNotis = styled.div`
  width: 90%;
  height: calc(100vh - 215px);
  display: flex;
  overflow: scroll;
  flex-direction: column;
  gap: 10px;
  padding-top: 20px;
  /* align-items: center; */

  @media (max-width: 650px) {
    align-items: center;
  }
  .ptur-fondo-loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  @media (max-width: 768px){
    width: 100%;
    height: calc(100vh - 180px);
    gap: 1px;
    padding-top: 1px;
  }

  

 .historial-btn {
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-latex30);
  text-align: center;
  width: 612px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 100%;
  }
 }
 .notifiaciones-previas {
  font-weight: 700;
  font-size: 16px;
  width: 612px;
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
    background-color: var(--color-white);
    padding: 20px;
  }
 }
`;

export const CardNoti = styled.div`
  width: 613px;
  height: 100px;
  padding: 20px;
  @media (max-width: 650px) {
    width: 90%;
  }
  background-color: var(--color-white);
  border: 1px solid #e6e6e6;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  .text-card-noti {
    width: 70%;
    height: 90%;
    margin-left: 20px;
    margin-top: 20px;
    @media (max-width: 650px) {
      overflow: scroll;
    }
    .title-noti {
      font-size: 14px;
      font-weight: ${({ active }) => {
        return active ? "400" : "bold";
    }};
      width: 100%;
      display: block;
    }
    .text-noti {
      font-size: 14px;
      width: 100%;
      display: block;
      line-height: 150%;
    }
  }
  .btn-card-noti {
    width: 30%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    button {
      width: 80px;
      height: 21px;
      border: 2px solid var(--color-latex30);
      background: none;
      padding: 15px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .fecha-noti {
      font-size: 14px;
      color: #a6a6a6;
    }
  }
`;

export const NewCardNoti = styled.div`
  width: 612px;
  height: 96px;
  min-height: 96px;
  box-shadow: 0px 9px 50px rgba(0, 0, 0, 0.07);
  border: 1px solid var(--color-grey95);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  .card-container {
    width: 90%;
    height: 90%;
    display: flex;
  }
  .card-container-text {
    width: 80%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    span {
        width: 100%;
    }
  }
  .card-container-btnDate {
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    button {
      width: 88px;
      height: 38px;
      border: 2px solid var(--color-latex30);
      color: var(--color-latex30);
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      background-color: var(--color-white);
      border-radius: 8px;
    }
    span {
        font-weight: 400;
        font-size: 14px;
        color: var(--color-latex30);
    }
  }
  .title-noti {
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
  }
  .text-noti{
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 120px;
    min-height: 120px;
    border-radius: 0;
    border: 1px solid var(--color-grey90);
    box-shadow: none;
    .card-container-btnDate{
        flex-direction: row;
        align-items: flex-end;
        width: 20%;
        button {
            display: none;
        }
        span {
        font-size: 12px;
        color: var(--color-latex30);
    }
    }
    .card-container-text {
      width: 80%;
      
      span {
        text-align: start;
        width: 100%;
      }
    }
  

  }
`;
